// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__2zQfi","text":"style_text__1wxtA"};